// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_e6-b";
export var colorBlue = "_e6-8";
export var colorDot = "_e6-0";
export var colorDotLarge = "_e6-2";
export var colorDotSmall = "_e6-1";
export var colorGreen = "_e6-7";
export var colorGrey = "_e6-3";
export var colorOrange = "_e6-5";
export var colorPink = "_e6-a";
export var colorPurple = "_e6-9";
export var colorRed = "_e6-4";
export var colorYellow = "_e6-6";